import { MapPin, ShieldCheck, Sparkles, Car } from "lucide-react";
import { FadeIn } from "./FadeIn";
import { BRANCH_HIGHLIGHTS } from "../data/content";

const ICONS = { MapPin, ShieldCheck, Sparkles, Car };

export const BranchHighlights = () => (
  <section
    id="about"
    data-testid="branch-highlights-section"
    className="px-4 sm:px-8 lg:px-12 py-16 md:py-24 max-w-7xl mx-auto"
  >
    <FadeIn className="flex flex-col gap-4 mb-14">
      <p className="text-amber-400 text-xs font-bold uppercase tracking-[0.3em]">
        Why Hammam Rajouri Garden
      </p>
      <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-black tracking-tighter text-white">
        The Rajouri Garden Branch Exclusive
      </h2>
      <p className="text-white/70 text-base md:text-lg font-light max-w-2xl">
        A discreet gentlemen's sanctuary crafted for the modern man of New Delhi.
      </p>
    </FadeIn>
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
      {BRANCH_HIGHLIGHTS.map((h, i) => {
        const Icon = ICONS[h.icon];
        return (
          <FadeIn key={h.title} delay={i * 0.1}>
            <div
              data-testid={`branch-card-${i}`}
              className="h-full bg-[#0c0c0c] border border-white/5 p-8 rounded-2xl hover:border-amber-400/50 hover:-translate-y-1 hover:shadow-[0_0_20px_rgba(212,175,55,0.1)] transition-all duration-300 flex flex-col items-start gap-4"
            >
              <div className="p-3 rounded-xl bg-amber-400/10 border border-amber-400/30">
                <Icon className="w-6 h-6 text-amber-400" />
              </div>
              <h3 className="font-serif text-xl font-bold text-white">
                {h.title}
              </h3>
              <p className="text-white/60 text-sm font-light leading-relaxed">
                {h.desc}
              </p>
            </div>
          </FadeIn>
        );
      })}
    </div>
  </section>
);
